import * as actionTypes from "./actionTypes";

export const chooseTreasure = (treasure: string, generalId: number) => ({
  type: actionTypes.CHOOSE_TREASURE,
  treasure,
  generalId
})
